<template>
  <el-dialog :title="title" :visible.sync="paramsSet.dialogVisible" width="auto" class="dialog-center" append-to-body>
    <div class="admin-role" v-loading="loading" :data-id="updateDataLocal">
      <el-form :model="ruleForm" :hide-required-asterisk="false" :rules="rules" size="mini" label-position="right" ref="ruleForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="角色名称：" prop="role_name">
              <el-input v-model="ruleForm.role_name" :disabled="paramsSet.edit_role_name_permission === false" maxlength="100" placeholder="请输入角色名称" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-transfer v-model="ruleForm.permissions_name" :data="dataset" :titles="['所有权限','角色权限']" :filterable="true">
        <span slot-scope="{ option }" :title="option.label">{{ option.label }}</span>
      </el-transfer>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <span class="cancel text-btn-active" @click="$emit('close')" style="margin-right: 24px;">取消</span>
        <el-button size="mini" type="primary" @click="save">确 定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import basiCcontainer from "@/layouts/app/components/basiCcontainer";
import api from "@/services/api/role/role"
export default {
  props: ['paramsSet', 'value', 'title'],
  components: {
    basiCcontainer,
  },
  computed: {
    updateDataLocal() {
      if (this.paramsSet.isEdit) {
        this.ruleForm.role_name = this.paramsSet.editData.role_name
        this.ruleForm.permissions_name = this.paramsSet.editData.permissions.map(res => res.permission_name)
      }
      return true
    },
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      ruleForm: {
        role_name: '',
        permissions_name: []
      },
      loading: false,
      dataset: [],
      rules: {
        role_name: [
          { required: true, message: '请输入角色名称', trigger: 'change' }
        ]
      }
    };
  },
  created() {
  },
  mounted() {
    this.init()
  },
  methods: {
    ...mapActions('permissions/permissions', ['permissionsIndex']),
    async init() {
      this.loading = true
      await api.permissionsIndex({}).then(res => {
        let arr = []
        res.forEach(res => {
          res.key = res.permission_name
          res.label = res.permission_name
          arr.push(res)
        })
        this.dataset = JSON.parse(JSON.stringify(arr))
      }).catch(err => { })
      this.loading = false
    },
    save() {
      let parmas = JSON.parse(JSON.stringify(this.ruleForm))
      parmas.role_name = parmas.role_name
      if (!this.paramsSet.isEdit) {
        api.addRole(parmas).then(res => {
          this.$message({ message: '新增角色成功', type: 'success' });
          this.$emit('complete')
        }).catch(res => {
        })
      } else {
        parmas.old_name = this.paramsSet.editData.role_name
        parmas.new_name = parmas.role_name
        delete parmas.role_name
        api.updateRole(parmas).then(res => {
          this.$message({ message: '编辑角色成功', type: 'success' });
          this.permissionsIndex()
          this.$emit('complete')
        }).catch(res => {
        })
      }
    }
  }
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.admin-role {
  .com-back {
    // position: fixed;
    // top: 116px;
    // left: 220px;
  }
  .el-cascader {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .block {
    margin-top: 30px;
  }
  ::v-deep {
    .el-tree {
      display: flex;
      flex-wrap: wrap;
      > .el-tree-node {
        margin-left: 6%;
      }
    }
  }
  .dialog-footer {
    margin-top: 20px;
    display: block;
  }
}
</style>
